import {Button, FormControlLabel, Grid} from '@material-ui/core';
import {Field, Form, Formik, FormikHelpers} from 'formik';
import * as React from 'react';
import {CreateUserInput, UpdateUserInput, User} from '../../graphql';
import {cleanFormValues, fieldProps} from './Formik';
import {FormikMaterialCheckbox} from './FormikMaterialCheckbox';
import {FormikMaterialTextField} from './FormikMaterialTextField';

interface UserFormProps {
  onSubmit: Function;
  user?: User;
}

type Values = Omit<CreateUserInput, 'clientMutationId'> | Omit<UpdateUserInput, 'clientMutationId'>;


const initialValues: Values = {
  username: '',
  email: '',
  firstName: '',
  lastName: '',
  enabled: false,
};

export const UserForm = (props: UserFormProps) => {
  const values = cleanFormValues(props.user, initialValues) as Values;
  return (
    <Formik
      initialValues={props.user ? values : initialValues}
      onSubmit={(
        values: Values,
        {setSubmitting}: FormikHelpers<Values>
      ) => {
        props.onSubmit(values);
        setSubmitting(false);
      }}
    >
      {formik => (
        <Form>
          <Grid container spacing={2}>

            <Grid item xs={12}>
              <Field {...fieldProps('username')} component={FormikMaterialTextField}/>
            </Grid>

            <Grid item xs={12}>
              <Field {...fieldProps('email')} component={FormikMaterialTextField}/>
            </Grid>

            <Grid item xs={12}>
              <Field {...fieldProps('firstName')} component={FormikMaterialTextField}/>
            </Grid>

            <Grid item xs={12}>
              <Field {...fieldProps('lastName')} component={FormikMaterialTextField}/>
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                label="Enabled"
                control={
                  <Field name="enabled" component={FormikMaterialCheckbox}/>
                }
              />
            </Grid>

            <Grid item xs={12}>
              <Grid container direction="row-reverse" alignItems="flex-end">
                <Grid item>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    size="large"
                    disabled={!formik.dirty || formik.isSubmitting}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>

          </Grid>
        </Form>
      )}
    </Formik>
  );
};
